var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "600px",
          },
          model: {
            value: _vm.dialogConfirm,
            callback: function ($$v) {
              _vm.dialogConfirm = $$v
            },
            expression: "dialogConfirm",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c(
                  "span",
                  {
                    staticClass: "text-h6 text-center w-100",
                  },
                  [_vm._v("ส่งโพยสำเร็จ")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "4",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "red darken-1 w-100 text-white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.redirectgame()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                แทงหวย\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "4",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "blue darken-1 w-100 text-white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.redirectpage()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                ดูโพย\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "4",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "green darken-1 w-100 text-white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reload()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                เล่นต่อ\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-12 text-xl text-primary text-center py-0",
        },
        [
          _vm.secondsLeft > 0
            ? _c("countdown", {
                attrs: {
                  "text-position": `text-center`,
                  "type-countdown": "lotto",
                  "seconds-left": _vm.secondsLeft,
                },
                on: {
                  "game-timeout": _vm.gameTimeout,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "bv-modal-rule",
            centered: "",
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(" กติกา " + _vm._s(_vm.gameMasterName)),
                  _c("br"),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-block text-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-body mt-0 px-1 py-0 text-center",
                },
                [
                  _c("iframe", {
                    attrs: {
                      id: "iframe",
                      src: _vm.ruleUrl,
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex",
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-width mx-1",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 btn-danger w-100",
                      attrs: {
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("bv-modal-rule")
                        },
                      },
                    },
                    [_vm._v("\n          ปิด\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.currentGameStatus == "open"
        ? _c(
            "div",
            {
              staticClass: "w-100",
            },
            [
              _vm.gameMasterSlug == "soidown_5" ||
              _vm.gameMasterSlug == "soidown" ||
              _vm.gameMasterSlug == "soidown_15" ||
              _vm.gameMasterSlug == "soidown_vip"
                ? _c(
                    "div",
                    {
                      staticClass: "row",
                    },
                    [
                      _vm._l(
                        _vm.buttonsActions,
                        function (buttonsActionItem, index) {
                          return _c(
                            "div",
                            {
                              key: buttonsActionItem.index,
                              staticClass: "col-4 col-lg-5 mb-3",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-100 btn btn-outline-dark text-lg",
                                  class: {
                                    active: _vm.containsBetOrShoot(
                                      _vm.candidatesBetOrShoot,
                                      index
                                    ),
                                  },
                                  attrs: {
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.provideBetOrShoot(
                                        buttonsActionItem,
                                        index
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(buttonsActionItem.name) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-4 col-lg-2 mb-3",
                        },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.bv-modal-rule",
                                  modifiers: {
                                    "bv-modal-rule": true,
                                  },
                                },
                              ],
                              staticClass: "btn btn-dark w-100 text-lg",
                            },
                            [_vm._v("\n          กติกา\n        ")]
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : _c(
                    "div",
                    {
                      staticClass: "row",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-6 col-lg-10 mb-3",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "w-100 btn btn-outline-dark text-lg py-3",
                              class: {
                                active: _vm.containsBetOrShoot(
                                  _vm.candidatesBetOrShoot,
                                  0
                                ),
                              },
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.provideBetOrShoot(
                                    _vm.buttonsActionItem,
                                    0
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          แทงเลข\n        ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-6 col-lg-2 mb-3",
                        },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.bv-modal-rule",
                                  modifiers: {
                                    "bv-modal-rule": true,
                                  },
                                },
                              ],
                              staticClass: "btn btn-dark w-100 text-lg py-3",
                            },
                            [_vm._v("\n          กติกา\n        ")]
                          ),
                        ]
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm.betOrShoot == 0 && _vm.secondsLeft > 0
                ? _c(
                    "div",
                    {
                      staticClass: "row justify-content-center mb-3 mt-3",
                    },
                    [
                      !_vm.gameMasterSlug.startsWith("step_")
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 mb-3 text-left",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card shadow-sm w-100",
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body row",
                                    },
                                    _vm._l(
                                      _vm.accepTantsTemp,
                                      function (acceptant, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: acceptant.index,
                                            staticClass: "col-6 px-1 mb-2",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "w-100 btn btn-pink-custom py-2",
                                                class: {
                                                  active: _vm.containsBetType(
                                                    _vm.candidatesBetType,
                                                    acceptant.slug
                                                  ),
                                                },
                                                attrs: {
                                                  type: "button",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.provideBetType(
                                                      acceptant,
                                                      index,
                                                      acceptant.slug
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(acceptant.display) +
                                                    "\n                "
                                                ),
                                                _c("br", {
                                                  staticClass: "d-lg-none",
                                                }),
                                                _vm._v(
                                                  "(\n                " +
                                                    _vm._s(
                                                      Intl.NumberFormat(
                                                        "en-US"
                                                      ).format(
                                                        acceptant.default_pay_rate
                                                      )
                                                    ) +
                                                    "\n                )\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.gameMasterSlug.startsWith("step_")
                        ? _c(
                            "span",
                            {
                              staticClass: "w-100 d-flex",
                            },
                            _vm._l(
                              _vm.buttonsTypes,
                              function (buttonTypeItem, index) {
                                return _c(
                                  "div",
                                  {
                                    key: buttonTypeItem.index,
                                    staticClass: "col-6 mb-3",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-100 btn btn-pink-custom text-lg py-3",
                                        class: {
                                          active: _vm.containsButtonType(
                                            _vm.candidatesButtonType,
                                            index
                                          ),
                                        },
                                        attrs: {
                                          type: "button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.provideButtonType(
                                              buttonTypeItem,
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(buttonTypeItem.name) +
                                            "\n          "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betOrShoot == 0 &&
                      _vm.secondsLeft > 0 &&
                      _vm.gameMasterSlug.startsWith("step_")
                        ? _c("bet-set", {
                            attrs: {
                              "lotto-numbers-with-type":
                                _vm.lottoNumbersWithType,
                            },
                            on: {
                              "child-digitClickSet": _vm.digitClickSet,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betOrShoot == 0 &&
                      _vm.secondsLeft > 0 &&
                      !_vm.gameMasterSlug.startsWith("step_")
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-7 col-xl-8 mb-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card shadow-sm",
                                },
                                [
                                  _vm.buttonSelectType == 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "card-body",
                                        },
                                        [
                                          _c("bet-button-group", {
                                            attrs: {
                                              "special-rate": _vm.specialRate,
                                              "url-api-lotto-rate":
                                                _vm.urlApiLottoRate,
                                              "digit-type":
                                                _vm.candidatesBetType,
                                              "lotto-numbers-with-type":
                                                _vm.lottoNumbersWithType,
                                              "accep-tants": _vm.acceptants,
                                            },
                                            on: {
                                              "child-digitClick":
                                                _vm.digitClick,
                                              "child-digitShuffleClick":
                                                _vm.digitClick,
                                              "child-digitClickSpecial":
                                                _vm.digitClickSpecial,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "card-body px-2",
                                        },
                                        [
                                          _c("pick-digit", {
                                            attrs: {
                                              "lotto-numbers-with-type":
                                                _vm.lottoNumbersWithType,
                                              "url-api-lotto-rate":
                                                _vm.urlApiLottoRate,
                                              "digit-type":
                                                _vm.candidatesBetType,
                                              "accep-tants": _vm.acceptants,
                                            },
                                            on: {
                                              "child-digitClick":
                                                _vm.digitClick,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-12 col-lg-5 col-xl-4 mb-3",
                        },
                        [
                          _c("lotto-review", {
                            attrs: {
                              "game-id": _vm.gameId,
                              "game-master-id": _vm.gameMasterId,
                              "url-api-lotto-template": _vm.urlApiLottoTemplate,
                              "url-api-get-template": _vm.urlApiGetTemplate,
                              "url-api-del-template": _vm.urlApiDelTemplate,
                              "url-api-lotto-rate": _vm.urlApiLottoRate,
                              "game-master-name": _vm.gameMasterName,
                              "game-master-slug": _vm.gameMasterSlug,
                              "url-api-lotto-bet": _vm.urlApiLottoBet,
                              "accep-tants": _vm.acceptants,
                              "game-limitations": _vm.gameLimitation,
                              "lotto-numbers-with-type":
                                _vm.lottoNumbersWithType,
                            },
                            on: {
                              "child-templateClick": _vm.templateClick,
                              "child-digitClickReview": _vm.digitClickReview,
                              "child-resetLottoNumbersWithType":
                                _vm.resetLottoNumbersWithType,
                              "child-emptyLottoNumbersWithType":
                                _vm.emptyLottoNumbersWithType,
                              "child-updateLottoWithType":
                                _vm.updateLottoWithType,
                              "child-digitClickSpecial": _vm.digitClickSpecial,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card mt-3",
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "card-body",
                                },
                                _vm._l(
                                  _vm.specialRateEntries,
                                  function (specialRateEntrie, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: specialRateEntrie.index,
                                      },
                                      [
                                        specialRateEntrie.special_rate.length >
                                        0
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "text-md text-left py-0 mt-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          specialRateEntrie.display
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.sortedArray(
                                                    specialRateEntrie.special_rate
                                                  ),
                                                  function (
                                                    special_rate,
                                                    index
                                                  ) {
                                                    return special_rate.type ==
                                                      "special"
                                                      ? _c(
                                                          "p",
                                                          {
                                                            key: special_rate.index,
                                                            staticClass:
                                                              "text-md text-left text-monospace my-0 py-1",
                                                          },
                                                          [
                                                            special_rate.rate_percent >
                                                            100
                                                              ? _c("font", [
                                                                  _vm._v(
                                                                    "\n                    เลขพิเศษ\n                  "
                                                                  ),
                                                                ])
                                                              : _c("font", [
                                                                  _vm._v(
                                                                    " เลขอั้น "
                                                                  ),
                                                                ]),
                                                            _vm._v(
                                                              "\n                  |\n                  " +
                                                                _vm._s(
                                                                  special_rate.digits
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card mt-3",
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "card-body",
                                },
                                _vm._l(
                                  _vm.gameLimitation,
                                  function (gamelimit) {
                                    return _c("div", [
                                      gamelimit.slug == "any_upper"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                วิ่งบน\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "any_under"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                วิ่งล่าง\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "2upper"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สองตัวบน\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "2under"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สองตัวล่าง\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "3upper"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สามตัวตรง\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "3shuffle"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สามตัวโต๊ด\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "3front"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สามตัวหน้า\n              "
                                              ),
                                            ]
                                          )
                                        : gamelimit.slug == "3back"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-left w-100 text-xl my-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                สามตัวหลัง\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-100 text-left text-lg",
                                        },
                                        [
                                          _vm._v(
                                            "\n                แทงขั้นต่ำต่อเลข : " +
                                              _vm._s(gamelimit.minimum) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-100 text-left text-lg",
                                        },
                                        [
                                          _vm._v(
                                            "\n                แทงสูงสุดต่อเลข : " +
                                              _vm._s(gamelimit.maximum) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "w-100",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 p-0 mb-3",
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.bv-modal-rule",
                          modifiers: {
                            "bv-modal-rule": true,
                          },
                        },
                      ],
                      staticClass: "btn btn-dark w-100 text-lg py-3 px-0",
                    },
                    [_vm._v("\n        กติกา\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header text-center",
                      class: _vm.changeClass(_vm.currentGameStatus),
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.changeTitle(_vm.currentGameStatus)) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.gameMasterSlug != "lotto_thai" &&
                  _vm.gameMasterSlug.search("step_") == -1
                    ? _c(
                        "div",
                        {
                          staticClass: "card-bory py-2",
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _vm.gameResults.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex text-xxl text-monospace",
                                },
                                [
                                  _vm._l(_vm.gameResults, function (result) {
                                    return result.result_key == "3upper"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-width text-center border-right",
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(result.result_value) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.gameResults, function (result) {
                                    return result.result_key == "2under"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-width text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(result.result_value) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                ],
                                2
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex text-xxl",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-width text-center border-right",
                                    },
                                    [_vm._v("รอผล")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-width text-center",
                                    },
                                    [_vm._v("รอผล")]
                                  ),
                                ]
                              ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMasterSlug.search("step_") != -1
                    ? _c(
                        "div",
                        {
                          staticClass: "card-bory py-2",
                        },
                        [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm.gameResults.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex text-xxl text-monospace",
                                },
                                _vm._l(_vm.gameResults, function (result) {
                                  return result.result_key == "4upper"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-width text-center border-right",
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(result.result_value) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex text-xxl",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-width text-center",
                                    },
                                    [_vm._v("รอผล")]
                                  ),
                                ]
                              ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMasterSlug == "lotto_thai"
                    ? _c(
                        "div",
                        {
                          staticClass: "card-bory py-2",
                        },
                        [
                          _vm._m(5),
                          _vm._v(" "),
                          _vm.gameResults.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex border-bottom mb-3 pb-3",
                                },
                                _vm._l(_vm.gameResults, function (result) {
                                  return result.result_key == "1st_prise"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex-width text-center",
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(result.result_value) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex border-bottom mb-3 pb-3",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-width text-center",
                                    },
                                    [_vm._v("รอผล")]
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _vm.gameResults.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-width text-center",
                                    },
                                    [
                                      _vm._l(
                                        _vm.gameResults,
                                        function (result) {
                                          return result.result_key ==
                                            "3digit_front_1"
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      result.result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      _vm._v("\n            ,\n            "),
                                      _vm._l(
                                        _vm.gameResults,
                                        function (result) {
                                          return result.result_key ==
                                            "3digit_front_2"
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      result.result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-width text-center border-left border-right",
                                    },
                                    [
                                      _vm._l(
                                        _vm.gameResults,
                                        function (result) {
                                          return result.result_key ==
                                            "3digit_back_1"
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      result.result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      _vm._v("\n            ,\n            "),
                                      _vm._l(
                                        _vm.gameResults,
                                        function (result) {
                                          return result.result_key ==
                                            "3digit_back_2"
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      result.result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-width text-center",
                                    },
                                    _vm._l(_vm.gameResults, function (result) {
                                      return result.result_key == "2digit"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(result.result_value) +
                                                "\n            "
                                            ),
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex",
                                },
                                [
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _vm._m(9),
                                ]
                              ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMasterSlug == "soidown" ||
                  _vm.gameMasterSlug == "soidown_5" ||
                  _vm.gameMasterSlug == "soidown_15" ||
                  _vm.gameMasterSlug == "soidown_vip"
                    ? _c(
                        "small",
                        {
                          staticClass: "text-red text-center py-1",
                        },
                        [
                          _vm._v(
                            "*เนื่องจากข้อมูลเป็นการแสดงผลแบบใกล้เคียง realtime\n        ดังนั้นให้ยึดผลจากเว็บได้คำนวนเสร็จแล้วเป็นหลัก"
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100 mt-6",
        },
        [
          _vm.betOrShoot == 1 &&
          (_vm.gameMasterSlug == "soidown_5" ||
            _vm.gameMasterSlug == "soidown" ||
            _vm.gameMasterSlug == "soidown_15" ||
            _vm.gameMasterSlug == "soidown_vip")
            ? _c(
                "div",
                {
                  staticClass: "row justify-content-center mb-3",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 mb-3",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card shadow-sm",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-header text-left bg-primary text-white",
                            },
                            [_vm._v("\n            ผลรวมปัจจุบัน\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card-body",
                            },
                            [
                              _c(
                                "h1",
                                {
                                  staticClass:
                                    "text-center text-monospace text-xxl",
                                },
                                [
                                  _vm._v("\n              ผลรวมเลขยิง"),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        parseInt(_vm.shootResult) -
                                          parseInt(_vm.shootWinFirstDigit) +
                                          parseInt(_vm.shootWinSecondDigit)
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between p-2 border-bottom",
                                },
                                [
                                  _vm._m(10),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "flex-width text-monospace text-xl text-uppercase text-success text-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.shootWinFirstDigit) + " |"
                                      ),
                                      _c("br", {
                                        staticClass: "d-lg-none",
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.shootWinFirst)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between p-2",
                                },
                                [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "flex-width text-monospace text-xl text-uppercase text-primary text-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.shootWinSecondDigit) + " |"
                                      ),
                                      _c("br", {
                                        staticClass: "d-lg-none",
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.shootWinSecond)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.currentGameStatus == "complete"
                                ? _c(
                                    "h1",
                                    {
                                      staticClass:
                                        "text-center text-monospace text-xxl",
                                    },
                                    [
                                      _vm._v(
                                        "\n              เลขที่ใช้ออกรางวัล"
                                      ),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(
                                        _vm._s(parseInt(_vm.shootResult)) +
                                          "\n              "
                                      ),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-red",
                                        },
                                        [
                                          _vm._v(
                                            "*ยึดเป็นตัวเลขสิ้นสุดในการออกผลรางวัล"
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentGameStatus == "open" ||
                  _vm.currentGameStatus == "closed"
                    ? _c("shoot", {
                        attrs: {
                          url: _vm.url,
                          "game-id": _vm.gameId,
                          "user-id": _vm.userId,
                          "game-master-id": _vm.gameMasterId,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("shoot-list", {
                    attrs: {
                      "game-id": _vm.gameId,
                      "game-master-id": _vm.gameMasterId,
                    },
                    on: {
                      "child-statusUpdate": _vm.statusUpdate,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass:
          "card-header bg-primary d-flex justify-content-between text-white py-2",
      },
      [_c("span", [_vm._v("เลือกรูปแบบ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header d-flex align-items-center",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-left",
          },
          [_vm._v("เลขอั้น / เลขพิเศษ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header",
      },
      [_c("h4", [_vm._v("เงือนไขการแทง")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center border-right",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวบน")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สองตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สี่ตัวบน")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("รางวัลที่ 1")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหน้า")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center border-left border-right",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหลัง")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("2ตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex-width text-center",
      },
      [_c("span", [_vm._v(" รอผล ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex-width text-center border-left border-right",
      },
      [_c("span", [_vm._v(" รอผล ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex-width text-center",
      },
      [_c("span", [_vm._v(" รอผล ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "span",
      {
        staticClass: "flex-width text-xl text-uppercase text-success text-left",
      },
      [
        _vm._v("อันดับที่ 1 "),
        _c("br", {
          staticClass: "d-lg-none",
        }),
        _vm._v("ใช้ในการ บวก"),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "span",
      {
        staticClass: "flex-width text-xl text-uppercase text-primary text-left",
      },
      [
        _vm._v("อันดับที่ 16 "),
        _c("br", {
          staticClass: "d-lg-none",
        }),
        _vm._v("ใช้ในการ ลบ"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }